module.exports = __webpack_public_path__ + "static/media/card-main4.eef3157a.png";